import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { Button } from './ui/button';

export function MarkdownRenderer({ content, onCTAClick }) {
  return (
    <div className="prose prose-lg max-w-none">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={{
          h1: ({ node, ...props }) => <h1 className="font-heading text-4xl font-bold text-white mt-0 mb-6" {...props} />,
          h2: ({ node, ...props }) => <h2 className="font-heading text-3xl font-bold text-white mt-12 mb-6" {...props} />,
          h3: ({ node, ...props }) => <h3 className="font-heading text-2xl font-bold text-white mt-8 mb-4" {...props} />,
          h4: ({ node, ...props }) => <h4 className="font-heading text-xl font-bold text-white mt-6 mb-3" {...props} />,
          p: ({ node, ...props }) => <p className="text-gray-300 leading-relaxed mb-4" {...props} />,
          ul: ({ node, ...props }) => <ul className="text-gray-300 my-6 list-disc pl-6" {...props} />,
          ol: ({ node, ...props }) => <ol className="text-gray-300 my-6 list-decimal pl-6" {...props} />,
          li: ({ node, ...props }) => <li className="my-2" {...props} />,
          strong: ({ node, ...props }) => <strong className="text-white font-semibold" {...props} />,
          em: ({ node, ...props }) => <em className="text-gray-300 italic" {...props} />,
          code: ({ node, inline, ...props }) => 
            inline ? (
              <code className="text-[#00E5FF] bg-white/5 px-1 py-0.5 rounded text-sm" {...props} />
            ) : (
              <code className="block text-[#00E5FF] bg-white/5 p-4 rounded my-4 overflow-x-auto" {...props} />
            ),
          blockquote: ({ node, ...props }) => (
            <blockquote className="border-l-4 border-[#00E5FF] pl-4 italic text-gray-400 my-6" {...props} />
          ),
          a: ({ node, children, href, ...props }) => {
            // Convert CTA links to buttons
            if (href === '#cta') {
              return (
                <div className="my-8 not-prose">
                  <Button 
                    size="lg"
                    className="bg-[#00E5FF] hover:bg-[#00E5FF]/90 text-black font-medium px-8 h-12"
                    onClick={onCTAClick}
                  >
                    Get Early Access to PitchMetric
                  </Button>
                </div>
              )
            }
            return <a href={href} className="text-[#00E5FF] no-underline hover:underline" {...props}>{children}</a>
          }
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}

